<template>
  <v-dialog
    persistent
    v-model="opened"
    max-width="600px"
    @keydown.esc="$emit('update:opened', false)"
  >
    <v-card class="content-container">
      <v-card-title class="title pt-2 pb-1">
        Select Firm-internal Status for
        {{ selectedQuestionnaires.length }} questionnaires
        <v-spacer />
        <v-btn
          fab
          small
          class="error--text text-none my-0"
          style="margin-right: -5px"
          flat
          @click="$emit('update:opened', false)"
        >
          <v-icon size="25">clear</v-icon>
        </v-btn>
      </v-card-title>
      <v-alert
        :value="true"
        outline
        block
        :icon="$vuetify.breakpoint.smAndUp ? 'info' : ''"
        color="primary"
        class="text-xs-left mb-4"
      >
        Please select Firm-internal Status. The client instruction is listed
        below.
      </v-alert>

      <v-list class="mt-2" one-line>
        <v-divider />
        <v-list-tile
          :key="0"
          @click="$emit('select-custom-status', null)"
          class="py-1"
        >
          <v-list-tile-content>
            <v-list-tile-title>No Status</v-list-tile-title>
            <v-list-tile-sub-title class="font-italic"
              >No Client Instruction</v-list-tile-sub-title
            >
          </v-list-tile-content>

          <v-list-tile-action>
            <v-icon>chevron_right</v-icon>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider />
        <div
          v-for="customStatus in currentFirm.firm_custom_statuses"
          :key="customStatus.id"
        >
          <v-list-tile
            @click="$emit('select-custom-status', customStatus)"
            class="py-1"
          >
            <v-list-tile-content>
              <v-list-tile-title
                v-text="customStatus.firm_user_display_status"
              ></v-list-tile-title>
              <v-list-tile-sub-title
                v-text="customStatus.client_display_status"
              ></v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-icon>chevron_right</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-divider />
        </div>
      </v-list>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    opened: {
      type: Boolean,
    },
    selectedQuestionnaires: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters({
      currentFirm: 'currentFirm',
    }),
  },
  methods: {},
};
</script>

<style scoped lang="postcss">
.title {
  font-weight: 700;
}
</style>
